import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ProvidersContext } from './contexts/providers.context';
import { InitialConfiguration } from './interfaces';

/**
 * This exports an object for the instances of the
 * financial calculator. All the instances need pass
 * an initial configuration with the initialize method,
 * this function `initialize` set the initial values
 * for the react context and this render the view of
 * the financial calculator.
 */
export default {
    initialize: (configuration: InitialConfiguration) => {
        const originsAllowed = ['*'];

        let componentRender: React.ReactElement;
        if (
            originsAllowed.some(
                (origin) => origin === window.location.origin || origin === '*',
            )
        ) {
            componentRender = (
                <React.StrictMode>
                    <ProvidersContext.Provider value={{ ...configuration }}>
                        <App />
                    </ProvidersContext.Provider>
                </React.StrictMode>
            );
        } else {
            componentRender = (
                <React.StrictMode>
                    <div>Hey! you don't have access.</div>
                </React.StrictMode>
            );
        }

        const container = document.getElementById(configuration?.id || '');
        if (container) {
            createRoot(container).render(componentRender);
        }
    },
};
